import Api from "../services/Api";

// Method to get runtime logging configuration data
export const getLoggingConfig = async () => {
    try {
      const response = await Api.get("/loggingConfig");
      console.log({response});
      if (response.status) {
        console.log(response.payload);
        return response.payload;
      } else {
        console.error(response.payload ? response.payload : response.message);
        throw new Error(response.payload ? response.payload : response.message);
      }
    } catch (error) {
      console.log(error);
      throw new Error(error.message, {cause: error});
    }
};


// Update runtime logging configuration data
export const updateLoggingConfig = async (data) => {
    try {

      const response = await Api.put("/loggingConfig", null, data);
      console.log({response});
      if (response.status) {
        return response.payload;
      } else {
        console.log(response.payload ? response.payload : response.message);
        throw new Error(response.payload ? response.payload : response.message);
      }
    } catch (error) {
      console.log(error);
      throw new Error(error.message, {cause: error});
    }
};

